module.exports = __webpack_public_path__ + "static/media/pepper.5c3e09c8.png";